import MovimientosBancarios from "../../components/MovimientosBancarios";

const MovimientosBancariosPage = () => <MovimientosBancarios />;

export default MovimientosBancariosPage;
